import { render } from "./RetailerSales.vue?vue&type=template&id=3574fdd0"
import script from "./RetailerSales.vue?vue&type=script&lang=js"
export * from "./RetailerSales.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__